import { API } from 'aws-amplify';
import moment from "moment-timezone";

// TEMPORARY - Remove this when COD project is stable
import { UpdateLeadBindingModel, ViewMetricsTotalsParams } from "../types";

export default class BaseAPI {

  protected static async callGET(path: string, queryStringParameters?: {}) {
    const init = {
      headers: {},
      queryStringParameters: queryStringParameters ? queryStringParameters : {},
    }
    // Use the encoded path in the API call
    return await API.get('codAPI', path, init);
  }

  protected static async callPost(path: string, request_body: {}) {
    const init = {
      headers: {
        'Content-Type': 'application/json'
      },
      body: request_body,
    }
    return await API.post('codAPI', path, init);
  }

  protected static async callDelete(path: string, queryStringParameters?: {}) {
    const init = {
      headers: {},
      queryStringParameters: queryStringParameters ? queryStringParameters : {},
    }
    return await API.del('codAPI', path, init);
  }

  protected static async callPut(path: string, request_body: {}) {
    const init = {
      headers: {
        'Content-Type': 'application/json'
      },
      body: request_body,
    }
    return await API.put('codAPI', path, init);
  }

  // TEMPORARY - Remove this when COD project is stable
  protected static view_metrics_search_params(totals_params: ViewMetricsTotalsParams): URLSearchParams {
    const { from_date, to_date, timezone } = totals_params;
    const params = new URLSearchParams();
    params.append('fromDate', from_date.format('YYYY-MM-DD HH:mm:ss'));
    params.append('toDate', to_date.format('YYYY-MM-DD HH:mm:ss'));
    params.append('offset', `${Number(moment.tz.zone(timezone.timeZoneName)?.utcOffset(new Date().getTime())) / 60}`);
    return params;
  }


  // TEMPORARY - Remove this when COD project is stable
  protected static update_lead_binding_model_to_url_search_params(update_lead_data: UpdateLeadBindingModel) {
    const params = new URLSearchParams();
    params.append('firstName', update_lead_data.firstName);
    params.append('lastName', update_lead_data.LastName);
    params.append('preferredContactMethodId', `${update_lead_data.preferredContactMethodId}`);
    params.append('email', update_lead_data.email);
    params.append('phone', update_lead_data.Phone);
    params.append('cellphone', update_lead_data.CellPhone);
    params.append('zipCode', update_lead_data.ZipCode);
    params.append('statusId', `${update_lead_data.statusId || ''}`);
    params.append('timeStamp', update_lead_data.timeStamp);
    params.append('justificationId', `${update_lead_data.justificationId || ''}`);
    params.append('justificationNote', update_lead_data.justificationNote || '');
    params.append('note', update_lead_data.note);
    params.append('city', update_lead_data.City);
    params.append('postalCodeId', update_lead_data.PostalCodeId || '');
    update_lead_data.customFieldValues.forEach((custom_field_value, index) => {
      params.append(`customFieldValues[${index}][customFieldId]`, `${custom_field_value.customFieldId}`);
      params.append(`customFieldValues[${index}][value]`, `${custom_field_value.value}`);
    });
    return params;
  }

}